import { createSaga } from './saga-helpers';

import * as Api from '../api/embeds-api';

const watchGetEmbeds = createSaga({
    type: 'EMBEDS_FETCH',
    fn: Api.fetchEmbeds,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        embeds: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateEmbed = createSaga({
    type: 'EMBED_CREATE',
    fn: Api.createEmbed,
    args: action => [action.payload.embed],
    successPayload: ({ id: embedId }, action) => ({
        embedId,
        fragment: action.payload.embed
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.embed
    })
});

const watchGetEmbed = createSaga({
    type: 'EMBED_FETCH',
    fn: Api.fetchEmbed,
    args: action => [action.payload.embedId],
    successPayload: embed => ({ embed })
});

const watchUpdateEmbed = createSaga({
    type: 'EMBED_UPDATE',
    fn: Api.updateEmbed,
    args: action => [action.payload.embedId, action.payload.embedProps],
    successPayload: embed => ({ embed })
});

const watchRemoveEmbed = createSaga({
    type: 'EMBED_REMOVE',
    fn: Api.removeEmbed,
    args: action => [action.payload.embedId]
});

const sagas = [watchGetEmbeds, watchCreateEmbed, watchGetEmbed, watchUpdateEmbed, watchRemoveEmbed];

export default sagas;
